var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPtBRreact = function SvgPtBRreact(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#73AF00",
    d: "M23.55 21H.45Q0 21 0 20.55V3.45Q0 3 .45 3h23.1q.45 0 .45.45v17.1q0 .45-.45.45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M11.85 6.3 3 11.7c-.3.15-.3.6 0 .75l8.7 5.25q.225.225.45 0l8.7-5.25c.3-.15.3-.6 0-.75l-8.7-5.25c0-.15-.3-.15-.3-.15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#41479B",
    d: "M15.3 12c0 1.8-1.5 3.3-3.3 3.3S8.7 13.8 8.7 12s1.5-3.3 3.3-3.3 3.3 1.5 3.3 3.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M9.15 10.35c-.15.3-.3.6-.3.9 1.8-.15 4.5.45 6.3 2.1.15-.3.15-.6.15-.9-1.8-1.65-4.2-2.25-6.15-2.1M12.15 13.2l.15.3h.3l-.15.15.15.3-.3-.15-.3.15.15-.3-.15-.15h.3zq0-.225 0 0M13.2 13.8l.15.15h-.15v.15h-.3v-.15h-.15zM11.7 12.6l.15.15h-.15v.15h-.3v-.15h-.15zM9.6 12.45l.15.15H9.6v.15h-.3v-.15h-.15zM11.4 13.8l.15.15h-.15v.15h-.3v-.15h-.15zq-.225 0 0 0M10.35 12.45q.225 0 0 0v.3h-.3v-.15H9.9zM13.35 10.5l.15.15h-.15v.15h-.3v-.15h-.15zM9.75 11.85q.225.225 0 0v.3h-.3V12H9.3zM10.2 13.2l.15.15-.15.15v.15l-.15-.15-.15.15v-.15l-.15-.15zM13.8 13.8q.225.225 0 0v.3h-.3v-.15h-.15c.3 0 .3 0 .45-.15M14.1 13.2l.15.15h-.15v.15h-.3v-.15h-.15z"
  })));
};
export default SvgPtBRreact;